// extracted by mini-css-extract-plugin
export var PreviewBanner = "PreviewBanner-module--PreviewBanner--5f2ec";
export var textContent = "PreviewBanner-module--textContent--83596";